/* ==========================================================================
   tl-landing.js — Tokyo Lifestyle · the landing-page engine
   --------------------------------------------------------------------------
   Runs the N-slot combo builder, the EN/বাংলা switch, the theme switch and the
   scroll choreography on every page built on snippets/tl-landing.liquid.

   Generated from tl-boxer.js (live 2026-10-08), the newest fork of the combo
   family, with everything that differed per page moved into the page itself:
     · #tle-data  — slots, discount rules, words, delivery, size chart, products
     · #tle-copy  — the JS-built English strings and the whole Bangla table,
                    already filled in with live prices by the Liquid
   so this file has no product, price or sentence of its own and every page on
   the engine shares it unchanged.

   Compatibility note: this page's traffic is overwhelmingly Android inside the
   Facebook / Instagram in-app browser, so the code deliberately stays inside
   ES2015 — no optional chaining, no nullish coalescing, no object spread, no
   Array.prototype.flat. IntersectionObserver and fetch are feature-detected.

   PRICING. One function, comboFor(), reproduces the store's automatic
   discounts for ANY basket (see the snippet's header for the verified carts):

       n >= freeAt   subtotal - the cheapest item     (Buy N-1 Get 1 Free)
       n >= 2        subtotal - pairOff               (flat off from two)
       otherwise     subtotal

   The forks carried two engines — a typed LADDER for flat-price collections
   and `cheapest-free` for mixed ones — and the boxer page broke exactly at the
   seam: when a ৳990 pack joined a ৳890 collection the flat ladder quoted ৳2670
   while checkout charged ৳2760. A flat collection is just the special case
   where every price is equal, so one formula covers both and there is no seam.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.getElementById('tle-root');
  var dataEl = document.getElementById('tle-data');
  var copyEl = document.getElementById('tle-copy');
  if (!root || !dataEl) return;

  var DATA;
  try {
    DATA = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var COPY = { en: {}, bn: {} };
  try {
    if (copyEl) COPY = JSON.parse(copyEl.textContent);
  } catch (e) {}

  var SLOTS = DATA.slots || 4;
  /* No discount can fire inside the bag (see the snippet's "plain mode"): the
     builder is a bag of up to SLOTS items, ready from the first one. */
  var PLAIN = DATA.plain === true;
  /* One item per checkout (checkout: 'single'): no bag. The size sheet carries
     the bill, the details form and Buy now, and it is a one-slot builder
     underneath, so pricing, stock and the hand-off are the same code. */
  var SINGLE = DATA.single === true;
  /* checkout: 'bag' — the Shirtology drop pages' bag. `slots` becomes the bag:
     one entry per PIECE, so claimed() still enforces stock and aggregate()
     still builds the permalink. SLOTS is the most an order may hold. */
  var BAG = DATA.bag === true;
  var BAG_KEY = DATA.bagKey || 'tle-bag';
  var NO_BUILDER = SINGLE || BAG;
  var SOURCE = DATA.source || '';
  var FREE_AT = DATA.freeAt || SLOTS;
  var PAIR_OFF = DATA.pairOff || 0;
  var UNIT = DATA.unit || 0;
  var PER_PACK = DATA.perPack || 1;
  var WORDS = DATA.words || {};
  var DELIVERY = DATA.delivery || { inside: 70, outside: 130 };
  var STYLES = DATA.styles || [];
  var SIZE_CHART = DATA.sizeChart || [];
  var SIZE_COLS = DATA.sizeCols || 0;
  var AUTOPLAY = DATA.autoplay !== false;
  var AUTOPLAY_MS = (DATA.autoplaySec || 4) * 1000;
  /* A timed automatic discount (pct_off / offer_until in the snippet). Liquid
     already zeroes it once the offer has ended, but a cached page outlives the
     `now` it was rendered with, so the browser checks the end time again. */
  var OFFER_UNTIL = DATA.offerUntil || 0;
  var OFFER_OVER = OFFER_UNTIL > 0 && Date.now() >= OFFER_UNTIL;
  var PCT_OFF = OFFER_OVER ? 0 : DATA.pctOff || 0;

  var reduceMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ── Copy ───────────────────────────────────────────────────────────────
     The markup's English is read out of the DOM (readEnglish), so page copy
     has one home. EN_JS is the English for strings the JS builds itself; BN is
     the whole Bangla table. Both arrive from the Liquid with every price
     already substituted, so neither can quote a stale number. */
  var BN = COPY.bn || {};
  var EN_JS = COPY.en || {};

  var EN = {};

  var lang = 'en';
  var dict = EN;

  function T(key) {
    if (lang === 'bn' && BN[key] != null && BN[key] !== '') return BN[key];
    return EN[key] != null ? EN[key] : '';
  }

  /* Capture the English copy straight out of the server-rendered markup so the
     page works with JS disabled and the dictionary has only one hand-written
     half to maintain. */
  function readEnglish() {
    var nodes = root.querySelectorAll('[data-i18n], [data-i18n-html]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var key = n.getAttribute('data-i18n') || n.getAttribute('data-i18n-html');
      if (key && EN[key] == null) {
        EN[key] = n.getAttribute('data-i18n-html') ? n.innerHTML : n.textContent;
      }
    }
  }

  function applyLang() {
    var html = document.documentElement;
    html.setAttribute('data-lang', lang);
    var nodes = root.querySelectorAll('[data-i18n], [data-i18n-html]');
    for (var i = 0; i < nodes.length; i++) {
      var n = nodes[i];
      var htmlKey = n.getAttribute('data-i18n-html');
      var key = htmlKey || n.getAttribute('data-i18n');
      if (!key) continue;
      var val = T(key);
      if (!val) continue;
      if (htmlKey) n.innerHTML = val;
      else n.textContent = val;
    }
    /* Figures the server printed — ladder prices, savings, gallery prices,
       delivery charges, tier quantities — carry their raw value, so they can
       follow the language too. The forks left these in Latin digits on an
       otherwise Bangla page. */
    var moneys = root.querySelectorAll('[data-money]');
    for (var m = 0; m < moneys.length; m++) {
      moneys[m].textContent = money(Number(moneys[m].getAttribute('data-money')));
    }
    var nums = root.querySelectorAll('[data-n]');
    for (var q = 0; q < nums.length; q++) {
      nums[q].textContent = digits(nums[q].getAttribute('data-n'));
    }
    var segs = root.querySelectorAll('[data-lang-btn]');
    for (var j = 0; j < segs.length; j++) {
      segs[j].setAttribute(
        'aria-pressed',
        segs[j].getAttribute('data-lang-btn') === lang ? 'true' : 'false'
      );
    }
    render();
  }

  function setLang(next) {
    lang = next === 'bn' ? 'bn' : 'en';
    try {
      localStorage.setItem('tle-lang', lang);
    } catch (e) {}
    applyLang();
  }

  /* ── Money ─────────────────────────────────────────────────────────────── */
  var BN_DIGITS = ['০', '১', '২', '৩', '৪', '৫', '৬', '৭', '৮', '৯'];

  function digits(str) {
    if (lang !== 'bn') return str;
    return String(str).replace(/[0-9]/g, function (d) {
      return BN_DIGITS[+d];
    });
  }

  function money(n) {
    var s = Math.round(n)
      .toString()
      .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '৳' + digits(s);
  }

  /* ── Pricing ───────────────────────────────────────────────────────────── */
  /* What Shopify will really charge for THIS basket. The store's discounts
     free the CHEAPEST eligible line at FREE_AT items and take a flat PAIR_OFF
     from two items up; at FREE_AT Shopify applies the better of the two, which
     is the free item for every price these pages sell. Mirrors the live cart. */
  function comboFor(prices) {
    var n = prices.length;
    if (!n) return 0;
    var subtotal = 0;
    var cheapest = Infinity;
    for (var i = 0; i < n; i++) {
      subtotal += prices[i];
      if (prices[i] < cheapest) cheapest = prices[i];
    }
    /* A percentage offer (plain pages): Shopify takes it off each line and
       rounds each line's discount to the paisa, so the bill does the same. */
    if (PCT_OFF > 0) {
      var off = 0;
      for (var k = 0; k < n; k++) off += Math.round(prices[k] * PCT_OFF) / 100;
      return Math.round((subtotal - off) * 100) / 100;
    }
    if (n >= FREE_AT) return subtotal - cheapest;
    if (n >= 2) return Math.max(0, subtotal - PAIR_OFF);
    return subtotal;
  }

  /* The lowest price any item on the page still offers — the best case for
     "add one more". Read from the live variants, not from UNIT, so it stays
     true when the cheapest product sells out. */
  function lowestLive() {
    var low = Infinity;
    for (var q = 0; q < STYLES.length; q++) {
      for (var w = 0; w < STYLES[q].variants.length; w++) {
        var vv = STYLES[q].variants[w];
        if (vv.ok && vv.price != null && vv.price < low) low = vv.price;
      }
    }
    return low === Infinity ? UNIT : low;
  }

  function slotPrices() {
    var prices = [];
    for (var i = 0; i < slots.length; i++) {
      if (slots[i]) prices.push(slots[i].price != null ? slots[i].price : UNIT);
    }
    return prices;
  }

  /* Index of the slot the discount actually makes free — the CHEAPEST filled
     slot, not simply the last one, because Shopify discounts the cheapest
     eligible line. Labelling any other slot "free" would misreport the bill. */
  function freeSlotIndex() {
    var count = 0;
    for (var i = 0; i < slots.length; i++) if (slots[i]) count++;
    if (count < FREE_AT) return -1;
    var best = -1;
    var low = Infinity;
    for (var j = 0; j < slots.length; j++) {
      if (!slots[j]) continue;
      var pr = slots[j].price != null ? slots[j].price : UNIT;
      if (pr < low) {
        low = pr;
        best = j;
      }
    }
    return best;
  }

  function priceState() {
    var prices = slotPrices();
    var subtotal = 0;
    for (var i = 0; i < prices.length; i++) subtotal += prices[i];
    var count = prices.length;
    var total = comboFor(prices);
    var ship = count ? DELIVERY[area] : 0;
    return {
      count: count,
      prices: prices,
      subtotal: subtotal,
      combo: total,
      /* Never negative: subtotal is the sum of the real variant prices and
         comboFor is the discounted figure, so this IS the discount. */
      saving: Math.max(0, subtotal - total),
      ship: ship,
      payable: total + ship
    };
  }

  /* ── State ─────────────────────────────────────────────────────────────── */
  var slots = [];
  if (!BAG) for (var s0 = 0; s0 < SLOTS; s0++) slots.push(null);
  /* The size chosen in the sheet, before Add to bag / Buy now commits it. */
  var sel = null;
  var area = 'inside';
  /* Set once the visitor taps a delivery area themselves — from then on the
     City / District field never overrides their choice. */
  var areaTouched = false;
  /* How many packs the visitor said they want, set from the price-ladder cards.
     It only governs whether the picker keeps chaining to the next slot — every
     slot stays fillable, so nobody is ever blocked from taking more. */
  var target = SLOTS;
  var otherCartItems = 0;

  /* ── Element refs ──────────────────────────────────────────────────────── */
  var el = {
    slots: root.querySelector('[data-slots]'),
    prog: root.querySelector('[data-prog]'),
    nudge: root.querySelector('[data-nudge]'),
    nudgeText: root.querySelector('[data-nudge-text]'),
    sumLines: root.querySelector('[data-sum-lines]'),
    sumCount: root.querySelector('[data-sum-count]'),
    rowSub: root.querySelector('[data-row-sub]'),
    rowSave: root.querySelector('[data-row-save]'),
    rowSaveWrap: root.querySelector('[data-row-save-wrap]'),
    rowShip: root.querySelector('[data-row-ship]'),
    total: root.querySelector('[data-total]'),
    cta: root.querySelector('[data-cta]'),
    ctaLabel: root.querySelector('[data-cta-label]'),
    msg: root.querySelector('[data-msg]'),
    dock: root.querySelector('[data-dock]'),
    dockV: root.querySelector('[data-dock-v]'),
    dockWas: root.querySelector('[data-dock-was]'),
    dockCta: root.querySelector('[data-dock-cta]'),
    dockCtaLabel: root.querySelector('[data-dock-cta-label]'),
    pick: root.querySelector('[data-pick]'),
    pickBody: root.querySelector('[data-pick-body]'),
    pickTitle: root.querySelector('[data-pick-title]'),
    pickStep: root.querySelector('[data-pick-step]'),
    toast: root.querySelector('[data-toast]'),
    fcart: root.querySelector('[data-fcart]'),
    fcartDots: root.querySelector('[data-fcart-dots]'),
    fcartK: root.querySelector('[data-fcart-k]'),
    fcartV: root.querySelector('[data-fcart-v]'),
    fcartSave: root.querySelector('[data-fcart-save]'),
    details: root.querySelector('[data-details]'),
    areaHint: root.querySelector('[data-area-hint]'),
    buy: root.querySelector('[data-buy]'),
    bag: root.querySelector('[data-bag]'),
    bagLines: root.querySelector('[data-bag-lines]'),
    bagBill: root.querySelector('[data-bag-bill]'),
    bagCount: root.querySelector('[data-bag-count]'),
    bagHeadCount: root.querySelector('[data-bag-head-count]'),
    buyPark: root.querySelector('[data-buy-park]')
  };

  /* ── Slots ─────────────────────────────────────────────────────────────── */
  function styleAt(i) {
    return STYLES[i];
  }

  function slotIsFree(index) {
    return freeSlotIndex() === index;
  }

  function renderSlots() {
    if (!el.slots) return;
    var out = '';
    for (var i = 0; i < SLOTS; i++) {
      var pick = slots[i];
      var n = i + 1 < 10 ? '0' + (i + 1) : String(i + 1);
      var isLast = i === SLOTS - 1 && FREE_AT <= SLOTS;

      if (!pick) {
        out +=
          '<button type="button" class="tle-slot' +
          (isLast ? ' tle-slot--free' : '') +
          '" data-slot="' +
          i +
          '">' +
          '<span class="tle-slot__n">' +
          digits(n) +
          '</span>' +
          '<span class="tle-slot__body">' +
          '<span class="tle-slot__plus" aria-hidden="true">+</span>' +
          '<span class="tle-slot__hint">' +
          (isLast ? T('build.slotFree') : T('build.slotEmpty')) +
          '</span>' +
          '</span>' +
          '</button>';
        continue;
      }

      var st = styleAt(pick.styleIdx);
      var freeTag = slotIsFree(i)
        ? '<span class="tle-slot__tag tle-slot__tag--free">' + T('build.free') + '</span>'
        : '<span class="tle-slot__tag">' + digits(n) + '</span>';

      out +=
        '<div class="tle-slot" data-filled="true" data-slot="' +
        i +
        '" role="button" tabindex="0">' +
        '<div class="tle-slot__pic">' +
        '<img src="' +
        st.img +
        '" alt="' +
        esc(st.title) +
        '" loading="lazy" width="300" height="300">' +
        freeTag +
        '<button type="button" class="tle-slot__x" data-clear="' +
        i +
        '" aria-label="' +
        esc(T('build.remove')) +
        '">&times;</button>' +
        '</div>' +
        '<div class="tle-slot__meta">' +
        '<span class="tle-slot__name">' +
        esc(st.name) +
        '</span>' +
        '<span class="tle-slot__size">' +
        esc(st.kicker) +
        ' · ' +
        esc(pick.size) +
        '</span>' +
        '</div>' +
        '</div>';
    }
    el.slots.innerHTML = out;
  }

  function renderProg() {
    if (!el.prog) return;
    var segs = el.prog.querySelectorAll('.tle-prog__seg');
    for (var i = 0; i < segs.length; i++) {
      segs[i].setAttribute('data-on', slots[i] ? 'true' : 'false');
    }
  }

  function renderTiers() {
    var tiers = root.querySelectorAll('[data-tier]');
    for (var i = 0; i < tiers.length; i++) {
      tiers[i].setAttribute(
        'aria-pressed',
        Number(tiers[i].getAttribute('data-tier')) === target ? 'true' : 'false'
      );
    }
  }

  /* The nudges quote what the NEXT item really does to this basket: its
     prices plus the cheapest item still live. The forks read these off a
     typed ladder, which is wrong the moment the basket holds a dearer item. */
  function renderNudge() {
    if (!el.nudge || !el.nudgeText) return;
    var p = priceState();
    if (PLAIN) {
      var pk = !p.count ? 'build.plain0' : p.count >= SLOTS ? 'build.plainFull' : 'build.plainMore';
      el.nudgeText.innerHTML = T(pk)
        .replace('{u}', money(lowestLive()))
        .replace('{n}', digits(p.count))
        .replace('{p}', money(p.combo));
      el.nudge.setAttribute('data-hot', p.count ? 'done' : 'false');
      return;
    }
    /* Hit the chosen tier below a full combo? Say so, rather than nagging on. */
    if (p.count > 0 && p.count === target && target < SLOTS) {
      el.nudgeText.innerHTML =
        T('build.ready').replace('{n}', digits(p.count)).replace('{p}', money(p.combo));
      el.nudge.setAttribute('data-hot', 'done');
      return;
    }

    var low = lowestLive();
    var withNext = p.prices.concat([low]);
    var nextTotal = comboFor(withNext);
    var step = Math.max(0, nextTotal - p.combo);
    var nextSubtotal = p.subtotal + low;
    var nextSave = Math.max(0, nextSubtotal - nextTotal);

    var key;
    if (p.count <= 0) key = 'build.nudge0';
    else if (p.count >= SLOTS) key = 'build.nudgeDone';
    else if (p.count === SLOTS - 1) {
      key = step > 0 ? 'build.nudgeLastPaid' : 'build.nudgeLastFree';
    } else key = 'build.nudgeMore';

    el.nudgeText.innerHTML = T(key)
      .replace('{u}', money(low))
      .replace('{n}', digits(p.count + 1))
      .replace('{t}', digits(SLOTS))
      .replace('{next}', money(nextTotal))
      .replace('{step}', money(step))
      .replace('{save}', money(p.count >= SLOTS ? p.saving : nextSave));

    el.nudge.setAttribute(
      'data-hot',
      p.count === SLOTS ? 'done' : p.count === SLOTS - 1 ? 'true' : 'false'
    );
  }

  function renderSummary() {
    var p = priceState();

    if (el.sumCount) {
      el.sumCount.textContent = digits(p.count) + ' / ' + digits(SLOTS) + ' ' + T('sum.count');
    }

    if (el.sumLines) {
      if (!p.count) {
        el.sumLines.innerHTML =
          '<p class="tle-sum__empty">' + esc(T('sum.empty')) + '</p>';
      } else {
        var out = '';
        for (var i = 0; i < SLOTS; i++) {
          if (!slots[i]) continue;
          var st = styleAt(slots[i].styleIdx);
          var free = slotIsFree(i);
          out +=
            '<div class="tle-sum__line' +
            (free ? ' tle-sum__line--free' : '') +
            '">' +
            '<span class="tle-cw tle-cw--sm" style="' +
            cwStyle(st) +
            '"></span>' +
            '<span class="tle-sum__line-n">' +
            esc(st.name) +
            ' · ' +
            esc(slots[i].size) +
            '</span>' +
            '<span class="tle-sum__line-p">' +
            (free ? T('build.free') : money(slots[i].price != null ? slots[i].price : UNIT)) +
            '</span>' +
            '</div>';
        }
        el.sumLines.innerHTML = out;
      }
    }

    if (el.rowSub) el.rowSub.textContent = money(p.subtotal);
    if (el.rowSave) el.rowSave.textContent = '− ' + money(p.saving);
    if (el.rowSaveWrap) el.rowSaveWrap.hidden = p.saving <= 0;
    if (el.rowShip) el.rowShip.textContent = p.count ? money(p.ship) : '—';
    if (el.total) el.total.textContent = money(p.payable);

    var ready = PLAIN ? p.count > 0 : p.count === SLOTS;
    var any = p.count > 0;
    if (el.cta) el.cta.disabled = !any;
    if (el.ctaLabel) {
      el.ctaLabel.textContent = !any
        ? T('sum.ctaWait')
        : el.details && el.details.hidden
        ? T('sum.ctaDetails')
        : T('sum.cta');
    }

    if (el.dockV) {
      /* The bag's dock shows the goods after any offer, before delivery. */
      el.dockV.textContent = money(SINGLE || (BAG && !p.count) ? lowestLive() : BAG ? p.combo : p.payable);
    }
    if (BAG && el.dock) {
      var dk = el.dock.querySelector('.tle-dock__k');
      if (dk) dk.textContent = p.count ? T('dock.bagK').replace('{n}', digits(p.count)) : T('dock.k');
    }
    if (el.dockWas) {
      el.dockWas.textContent = p.saving > 0 ? money(BAG ? p.subtotal : p.subtotal + p.ship) : '';
      el.dockWas.hidden = p.saving <= 0;
    }
    if (el.dockCta) el.dockCta.disabled = false;
    if (el.dockCtaLabel) {
      el.dockCtaLabel.textContent = BAG
        ? (any ? T('dock.bagGo') : T('dock.pick'))
        : any && !SINGLE ? T('dock.cta') : T('dock.pick');
    }

    if (el.msg && el.msg.getAttribute('data-kind') !== 'error') {
      el.msg.textContent =
        otherCartItems > 0
          ? T('sum.cartHas').replace('{n}', digits(otherCartItems))
          : '';
    }

    if (!NO_BUILDER && p.count === SLOTS && !reduceMotion) burst();
    if (BAG) renderBag();
    renderAreaHint();
  }

  /* Floating tracker: progress dots, running total, and the saving once one
     exists. At a full combo it turns into the checkout button rather than a
     second "go to the builder" link, since the builder's work is done. */
  function renderFloatCart() {
    if (!el.fcart) return;
    /* The desktop tracker follows a basket; a single-item page has none. */
    if (NO_BUILDER) {
      el.fcart.style.display = 'none';
      return;
    }
    var p = priceState();

    if (el.fcartDots && el.fcartDots.children.length !== SLOTS) {
      var html = '';
      for (var i = 0; i < SLOTS; i++) html += '<span class="tle-fcart__dot"></span>';
      el.fcartDots.innerHTML = html;
    }
    if (el.fcartDots) {
      for (var j = 0; j < el.fcartDots.children.length; j++) {
        el.fcartDots.children[j].setAttribute('data-on', slots[j] ? 'true' : 'false');
      }
    }

    var ready = PLAIN ? p.count > 0 : p.count === SLOTS;
    el.fcart.setAttribute('data-state', ready ? 'ready' : p.count ? 'building' : 'empty');
    if (el.fcartK) {
      el.fcartK.textContent = !p.count
        ? T('fcart.empty')
        : ready
        ? T('fcart.ready')
        : T('fcart.of').replace('{n}', digits(p.count)).replace('{t}', digits(SLOTS));
    }
    if (el.fcartV) el.fcartV.textContent = money(p.payable);
    if (el.fcartSave) {
      el.fcartSave.hidden = p.saving <= 0;
      el.fcartSave.textContent = T('fcart.save').replace('{p}', money(p.saving));
    }
  }

  function render() {
    renderTiers();
    renderSlots();
    renderProg();
    renderNudge();
    renderSummary();
    renderFloatCart();
  }

  /* ── Picker ────────────────────────────────────────────────────────────── */
  var pickSlot = -1;

  function cwStyle(st) {
    var a = st.cw && st.cw[0] ? st.cw[0] : '#16171a';
    var b = st.cw && st.cw[1] ? st.cw[1] : a;
    var c = st.cw && st.cw[2] ? st.cw[2] : b;
    return '--cw-a:' + a + ';--cw-b:' + b + ';--cw-c:' + c;
  }

  function esc(v) {
    return String(v == null ? '' : v)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  /* A product's own chart header without its unit: "Trouser Waist (in)" ->
     "Trouser Waist". The chart's title already says inches, and the "(in)" on
     every column is what pushed the trouser columns off a phone screen. The
     section's tables (snippets/tl-landing.liquid) strip the same suffixes. */
  function unitless(head) {
    return String(head == null ? '' : head).replace(/\s*\((?:in|inch|inches)\.?\)\s*$/i, '');
  }

  function openPicker(index) {
    pickSlot = index;
    if (!el.pick) return;
    el.pick.setAttribute('data-open', 'true');
    /* iOS Safari ignores overflow:hidden on <html> alone. */
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    renderPickStyles();
  }

  function closePicker() {
    if (!el.pick) return;
    el.pick.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    pickSlot = -1;
  }

  function stockLeft(st) {
    var n = 0;
    for (var i = 0; i < st.variants.length; i++) {
      if (st.variants[i].ok) n += Math.max(0, st.variants[i].qty);
    }
    return n;
  }

  /* How many of this exact variant the builder has already claimed, so we can
     stop someone reserving 3 of a size that only has 2 in stock. */
  function claimed(variantId, ignoreSlot) {
    var n = 0;
    for (var i = 0; i < slots.length; i++) {
      if (i === ignoreSlot) continue;
      if (slots[i] && slots[i].variantId === variantId) n++;
    }
    return n;
  }

  function renderPickStyles() {
    if (!el.pickBody) return;
    el.pick.setAttribute('data-step', '1');
    if (el.pickTitle) el.pickTitle.textContent = T('pick.h1');
    if (el.pickStep) {
      /* No steps or slots to count on a single-item page. */
      el.pickStep.textContent = NO_BUILDER
        ? ''
        : T('pick.step1') + ' · ' + T('pick.slot').replace('{n}', digits(pickSlot + 1));
    }

    var out = '<div class="tle-pgrid">';
    for (var i = 0; i < STYLES.length; i++) {
      var st = STYLES[i];
      var left = stockLeft(st);
      var out_ = left <= 0;
      out +=
        '<button type="button" class="tle-pcard" data-style="' +
        i +
        '"' +
        (out_ ? ' data-out="true" disabled' : '') +
        '>' +
        '<span class="tle-pcard__pic">' +
        '<img src="' +
        st.img +
        '" alt="' +
        esc(st.title) +
        '" loading="lazy" width="360" height="450">' +
        (out_
          ? '<span class="tle-pcard__low">' + esc(T('pick.out')) + '</span>'
          : left <= 3
          ? '<span class="tle-pcard__low">' +
            esc(T('pick.low').replace('{n}', digits(left))) +
            '</span>'
          : '') +
        '</span>' +
        '<span class="tle-pcard__meta">' +
        '<span class="tle-pcard__cw">' +
        '<span class="tle-cw" style="' +
        cwStyle(st) +
        '"></span>' +
        '<span class="tle-pcard__name">' +
        esc(st.name) +
        '</span>' +
        '</span>' +
        '<span class="tle-pcard__series">' +
        esc(st.kicker) +
        '</span>' +
        '</span>' +
        '</button>';
    }
    out += '</div>';
    parkBuy();
    el.pickBody.innerHTML = out;
    el.pickBody.scrollTop = 0;
  }

  function renderPickSizes(styleIdx) {
    if (!el.pickBody) return;
    var st = STYLES[styleIdx];
    /* A shop page's sheet is "your pick", not step 2 of a builder: no back
       arrow (there is no step 1 the visitor ever saw), and the header names
       the design instead of the task. */
    el.pick.setAttribute('data-step', NO_BUILDER ? 'sheet' : '2');
    var backBtn = el.pick.querySelector('.tle-pick__back');
    if (backBtn) backBtn.setAttribute('aria-label', T('pick.back'));
    if (el.pickTitle) {
      if (NO_BUILDER) {
        el.pickTitle.innerHTML =
          '<small class="tle-pick__eyebrow">' + esc(T('sheet.pick')) + (st.kicker ? ' · ' + esc(st.kicker) : '') + '</small>' +
          '<span class="tle-pick__name">' + esc(st.name) + '</span>';
      } else {
        el.pickTitle.textContent = T('pick.h2');
      }
    }
    if (el.pickStep) {
      /* No steps or slots to count on a single-item page. */
      el.pickStep.textContent = NO_BUILDER
        ? ''
        : T('pick.step2') + ' · ' + T('pick.slot').replace('{n}', digits(pickSlot + 1));
    }

    var chips = '';
    for (var i = 0; i < st.variants.length; i++) {
      var v = st.variants[i];
      var free = Math.max(0, v.qty - claimed(v.id, pickSlot));
      var can = v.ok && free > 0;
      chips +=
        '<button type="button" class="tle-size" data-variant="' +
        v.id +
        '" data-size="' +
        esc(v.size) +
        '" data-style="' +
        styleIdx +
        '" data-price="' +
        (v.price != null ? v.price : UNIT) +
        '"' +
        (can ? '' : ' disabled') +
        '>' +
        esc(v.size) +
        (can && free <= 3 && !NO_BUILDER
          ? '<small>' + esc(digits(free) + ' ' + T('pick.left')) + '</small>'
          : '') +
        '</button>';
    }

    /* The chart is scoped to the sizes THIS pack offers, and sold-out rows are
       struck through to match the chips above — a chart listing sizes you cannot
       pick would be worse than no chart. Open by default where there is room;
       collapsed on a phone so it never buries the size buttons. */
    var offered = {};
    for (var v = 0; v < st.variants.length; v++) {
      offered[st.variants[v].size] = st.variants[v];
    }
    /* A product that carries its OWN chart (chart_from: 'description') shows
       that one: its first row is the header, in the product's own words. */
    var own = st.chart && st.chart.length > 1 ? st.chart : null;
    var source = own ? own.slice(1) : SIZE_CHART;
    var rows = '';
    for (var c = 0; c < source.length; c++) {
      var row = source[c];
      var variant = offered[row[0]];
      if (!variant) continue;
      var out = !(variant.ok && Math.max(0, variant.qty - claimed(variant.id, pickSlot)) > 0);
      rows += '<tr' + (out ? ' data-out="true"' : '') + '><th scope="row">' + esc(row[0]) + '</th>';
      for (var cc = 1; cc < row.length; cc++) rows += '<td>' + esc(digits(row[cc])) + '</td>';
      rows += '</tr>';
    }
    var heads = '';
    if (own) {
      for (var oh = 0; oh < own[0].length; oh++) heads += '<th>' + esc(unitless(own[0][oh])) + '</th>';
    } else {
      for (var h = 0; h < SIZE_COLS; h++) heads += '<th>' + esc(T('size.th' + h)) + '</th>';
    }
    var chart = !rows ? '' :
      '<details class="tle-chart"' + (window.innerWidth >= 620 ? ' open' : '') + '>' +
      '<summary><span>' + esc(T('pick.chart')) + '</span>' +
      '<small>' + esc(T('pick.chartHint')) + '</small>' +
      '<span class="tle-chart__pm" aria-hidden="true"></span></summary>' +
      '<div class="tle-chart__scroll"><table class="tle-chart__table' + (own ? ' tle-chart__table--fit' : '') + '"><thead><tr>' +
      heads +
      '</tr></thead><tbody>' + rows + '</tbody></table></div>' +
      (T('size.note') ? '<p class="tle-chart__note">' + esc(T('size.note')) + '</p>' : '') +
      '</details>';

    parkBuy();
    if (SINGLE && slots[0] && slots[0].styleIdx !== styleIdx) {
      /* A different product: its bill must not show the last one's size. */
      slots[0] = null;
      render();
    }
    if (NO_BUILDER) {
      el.pickBody.innerHTML =
        '<div class="tle-psheet">' +
        '<div class="tle-psheet__pic"><img src="' + (st.imgLg || st.img) + '" alt="' + esc(st.title) + '" width="900" height="1125"></div>' +
        '<p class="tle-label tle-psheet__k">' + esc(T('sheet.size')) + '</p>' +
        '<div class="tle-sizes">' + chips + '</div>' +
        chart +
        '</div>';
    } else
    el.pickBody.innerHTML =
      '<div class="tle-psize">' +
      '<div class="tle-psize__pic"><img src="' +
      st.img +
      '" alt="' +
      esc(st.title) +
      '" width="420" height="525"></div>' +
      '<div class="tle-psize__info">' +
      '<div class="tle-pcard__cw" style="margin-bottom:10px">' +
      '<span class="tle-cw tle-cw--lg" style="' +
      cwStyle(st) +
      '"></span>' +
      '<span class="tle-pcard__series">' +
      esc(st.kicker) +
      '</span>' +
      '</div>' +
      '<h4 class="tle-head tle-psize__name">' +
      esc(st.name) +
      '</h4>' +
      '<p class="tle-psize__k">' +
      esc(st.title) +
      '</p>' +
      '<div class="tle-sizes">' +
      chips +
      '</div>' +
      chart +
      '</div>' +
      '</div>';
    if (SINGLE && el.buy) {
      var host = el.pickBody.querySelector('.tle-psheet, .tle-psize');
      if (host) host.appendChild(el.buy);
      markPicked();
    }
    if (BAG) {
      sel = null;
      var bar = document.createElement('div');
      bar.className = 'tle-sheetbar';
      var lowP = Infinity;
      for (var lp = 0; lp < st.variants.length; lp++) if (st.variants[lp].price < lowP) lowP = st.variants[lp].price;
      bar.innerHTML =
        '<p class="tle-sheetbar__msg" data-sheet-msg role="status" aria-live="polite"></p>' +
        '<div class="tle-sheetbar__price"><span>' + esc(T('sheet.price')) + '</span>' +
        '<b class="tle-num" data-sheet-price>' + money(lowP === Infinity ? UNIT : lowP) + '</b></div>' +
        '<button type="button" class="tle-btn tle-btn--ghost tle-btn--lg" data-bag-add>' + esc(T('bag.add')) + '</button>' +
        '<button type="button" class="tle-btn tle-btn--brass tle-btn--lg" data-bag-buy>' + esc(T('bag.buy')) + '</button>';
      /* The bar is the sheet's footer, outside the photo/size column. */
      var host2 = el.pickBody.querySelector('.tle-psheet, .tle-psize');
      if (host2) host2.appendChild(bar);
    }
    el.pickBody.scrollTop = 0;
  }

  /* The checkout block is ONE server-rendered node (its inputs keep what the
     buyer typed). It lives in the sheet while a size step is open, and is put
     back in its hidden parking spot before the sheet body is replaced, or the
     innerHTML write would destroy it along with the details typed into it. */
  function parkBuy() {
    if (SINGLE && el.buy && el.buyPark && el.buy.parentNode !== el.buyPark) {
      el.buyPark.appendChild(el.buy);
    }
  }

  function picked() {
    return BAG ? sel : slots[0];
  }

  /* ── Bag (checkout: 'bag') ─────────────────────────────────────────────── */
  function bagCount() {
    var n = 0;
    for (var i = 0; i < slots.length; i++) if (slots[i]) n++;
    return n;
  }

  function persistBag() {
    if (!BAG) return;
    var out = [];
    for (var i = 0; i < slots.length; i++) {
      var x = slots[i];
      if (x) out.push({ v: x.variantId, st: STYLES[x.styleIdx] ? STYLES[x.styleIdx].id : 0, size: x.size });
    }
    try {
      localStorage.setItem(BAG_KEY, JSON.stringify(out));
    } catch (e) {}
  }

  /* A remembered bag is re-checked against what the page sells TODAY: a line
     whose product or size has gone, or more pieces than are left, is dropped
     silently rather than carried into a checkout that would refuse it. Price
     comes from today's variant, never from storage. */
  function restoreBag() {
    if (!BAG) return;
    var saved = [];
    try {
      saved = JSON.parse(localStorage.getItem(BAG_KEY) || '[]') || [];
    } catch (e) {}
    for (var i = 0; i < saved.length && slots.length < SLOTS; i++) {
      for (var si = 0; si < STYLES.length; si++) {
        if (STYLES[si].id !== saved[i].st) continue;
        for (var vi = 0; vi < STYLES[si].variants.length; vi++) {
          var v = STYLES[si].variants[vi];
          if (v.id !== saved[i].v || !v.ok || claimed(v.id, -1) >= v.qty) continue;
          slots.push({ styleIdx: si, variantId: v.id, size: v.size, price: v.price != null ? v.price : UNIT });
        }
      }
    }
    persistBag();
  }

  function sheetMsg(text) {
    var m = el.pickBody && el.pickBody.querySelector('[data-sheet-msg]');
    if (m) m.textContent = text || '';
  }

  /* Commit the size chosen in the sheet. Refuses — with the reason, in the
     sheet — rather than adding a piece the store cannot ship. */
  function addToBag() {
    if (!sel) {
      sheetMsg(T('bag.pickSize'));
      return false;
    }
    if (bagCount() >= SLOTS) {
      sheetMsg(T('bag.full').replace('{n}', digits(SLOTS)));
      return false;
    }
    var st = STYLES[sel.styleIdx];
    var v = null;
    for (var i = 0; i < st.variants.length; i++) if (st.variants[i].id === sel.variantId) v = st.variants[i];
    var left = v ? v.qty - claimed(v.id, -1) : 0;
    if (left <= 0) {
      sheetMsg(T('bag.max').replace('{n}', digits(0)));
      return false;
    }
    slots.push({ styleIdx: sel.styleIdx, variantId: sel.variantId, size: sel.size, price: sel.price });
    persistBag();
    render();
    return true;
  }

  function openBag() {
    if (!el.bag) return;
    if (el.pick && el.pick.getAttribute('data-open') === 'true') closePicker();
    renderBag();
    el.bag.setAttribute('data-open', 'true');
    document.documentElement.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
  }

  function closeBag() {
    if (!el.bag) return;
    el.bag.setAttribute('data-open', 'false');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
  }

  /* One row per VARIANT with its quantity; − and + move single pieces, and +
     stops at the stock that is left. */
  function renderBag() {
    if (!BAG) return;
    var n = bagCount();
    if (el.bagCount) {
      el.bagCount.textContent = digits(n);
      el.bagCount.hidden = n === 0;
    }
    if (el.bagHeadCount) el.bagHeadCount.textContent = n ? T('bag.items').replace('{n}', digits(n)) : '';
    if (el.bagBill) el.bagBill.hidden = n === 0;
    var browse = el.bag && el.bag.querySelector('[data-bag-browse]');
    if (browse) browse.hidden = n > 0;
    if (!n && el.details) el.details.hidden = true;
    if (!el.bagLines) return;
    if (!n) {
      el.bagLines.innerHTML = '<p class="tle-bag__empty">' + esc(T('bag.empty')) + '</p>';
      return;
    }
    var order = [];
    var qty = {};
    var first = {};
    for (var i = 0; i < slots.length; i++) {
      var x = slots[i];
      if (!x) continue;
      if (qty[x.variantId] == null) {
        qty[x.variantId] = 0;
        first[x.variantId] = x;
        order.push(x.variantId);
      }
      qty[x.variantId]++;
    }
    var out = '';
    for (var j = 0; j < order.length; j++) {
      var line = first[order[j]];
      var st = STYLES[line.styleIdx];
      var q = qty[order[j]];
      var v = null;
      for (var k = 0; k < st.variants.length; k++) if (st.variants[k].id === line.variantId) v = st.variants[k];
      var canMore = v && q < v.qty && n < SLOTS;
      out +=
        '<div class="tle-bag__line" data-line="' + line.variantId + '">' +
        '<img src="' + st.img + '" alt="' + esc(st.title) + '" width="72" height="90" loading="lazy">' +
        '<div class="tle-bag__meta">' +
        '<span class="tle-bag__name">' + esc(st.name) + '</span>' +
        '<span class="tle-bag__sub">' + esc(st.kicker) + ' · ' + esc(line.size) + '</span>' +
        '<span class="tle-bag__qty">' +
        '<button type="button" class="tle-icobtn" data-line-dec aria-label="−">−</button>' +
        '<b>' + digits(q) + '</b>' +
        '<button type="button" class="tle-icobtn" data-line-inc aria-label="+"' + (canMore ? '' : ' disabled') + '>+</button>' +
        '</span>' +
        '</div>' +
        '<div class="tle-bag__end">' +
        '<button type="button" class="tle-icobtn tle-bag__rm" data-line-rm aria-label="' + esc(T('bag.remove')) + '">' +
        '<svg viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" aria-hidden="true"><path d="M6 6l8 8M14 6l-8 8"></path></svg></button>' +
        '<span class="tle-num tle-bag__price">' + money(line.price * q) + '</span>' +
        '</div>' +
        '</div>';
    }
    el.bagLines.innerHTML = out;
  }

  function markPicked() {
    var chips = el.pickBody.querySelectorAll('[data-variant]');
    for (var i = 0; i < chips.length; i++) {
      chips[i].setAttribute(
        'aria-pressed',
        picked() && Number(chips[i].getAttribute('data-variant')) === picked().variantId ? 'true' : 'false'
      );
    }
  }

  /* ── Cart ──────────────────────────────────────────────────────────────── */
  function aggregate() {
    var map = {};
    var order = [];
    for (var i = 0; i < slots.length; i++) {
      if (!slots[i]) continue;
      var id = slots[i].variantId;
      if (map[id] == null) {
        map[id] = 0;
        order.push(id);
      }
      map[id]++;
    }
    var items = [];
    for (var j = 0; j < order.length; j++) {
      items.push({ id: Number(order[j]), quantity: map[order[j]] });
    }
    return items;
  }

  function setMsg(text, kind) {
    if (!el.msg) return;
    el.msg.textContent = text || '';
    if (kind) el.msg.setAttribute('data-kind', kind);
    else el.msg.removeAttribute('data-kind');
  }

  function toast(text) {
    if (!el.toast) return;
    el.toast.textContent = text;
    el.toast.setAttribute('data-show', 'true');
    window.setTimeout(function () {
      el.toast.setAttribute('data-show', 'false');
    }, 2400);
  }


  /* ── On-page details → pre-filled Shopify checkout ──────────────────────
     A theme cannot create an order, so the hand-off goes through a cart
     permalink: /cart/{variant}:{qty},...?checkout[...]=... . A permalink also
     REPLACES the cart rather than adding to it, which conveniently rules out a
     stale cart contaminating the combo total. Verified on this store that
     email, first/last name, address1, city, postalCode and phone all pre-fill,
     and the automatic combo discount still applies. */
  function detField(name) {
    var elx = root.querySelector('[data-det="' + name + '"]');
    return elx ? String(elx.value || '').trim() : '';
  }

  function setFieldError(name, msg) {
    var elx = root.querySelector('[data-det="' + name + '"]');
    if (!elx) return;
    elx.setAttribute('data-invalid', msg ? 'true' : 'false');
    var holder = elx.parentNode;
    var err = holder.querySelector('.tle-field__err');
    if (msg) {
      if (!err) {
        err = document.createElement('span');
        err.className = 'tle-field__err';
        holder.appendChild(err);
      }
      err.textContent = msg;
    } else if (err) {
      err.parentNode.removeChild(err);
    }
  }

  /* Bangladeshi mobile numbers: 11 digits starting 01, optionally +880/880. */
  function normalizeBdPhone(raw) {
    var d = String(raw || '').replace(/[^0-9]/g, '');
    if (d.indexOf('880') === 0) d = d.slice(3);
    if (d.length === 10 && d.indexOf('1') === 0) d = '0' + d;
    return /^01[3-9][0-9]{8}$/.test(d) ? d : '';
  }

  /* The email is optional, but one the checkout rejects is a dead end: the
     permalink lands on Shopify's "Something went wrong — Cart Error: Email is
     invalid" page with no way back into the order. `rina@gmail` passes the
     browser's own type=email check and still fails there, hence the dot. */
  function emailOk(v) {
    return v === '' || /^[^\s@]+@[^\s@]+\.[^\s@.]{2,}$/.test(v);
  }

  /* ── Delivery area from the City / District field ──────────────────────
     Most web orders ship OUTSIDE Dhaka, yet the area starts on Inside Dhaka,
     so the total a Sylhet or Cumilla buyer read was ৳60 short of the real one.
     A named district outside Dhaka switches the area; "Dhaka" switches it
     back; anything else (Mirpur, Uttara, a typo) leaves it alone. A tap on the
     area itself always wins. Names are compacted — lowercase letters only —
     so "Cox's Bazar", "coxsbazar" and "COX BAZAR" all match. */
  var OUTSIDE_DHAKA = (
    'gazipur,narayanganj,narayangonj,narsingdi,narshingdi,manikganj,munshiganj,tangail,kishoreganj,' +
    'faridpur,gopalganj,madaripur,rajbari,shariatpur,' +
    'chattogram,chittagong,ctg,coxsbazar,coxbazar,cumilla,comilla,feni,noakhali,lakshmipur,laxmipur,' +
    'chandpur,brahmanbaria,rangamati,khagrachari,khagrachhari,bandarban,' +
    'rajshahi,bogura,bogra,pabna,sirajganj,natore,naogaon,chapai,joypurhat,' +
    'khulna,jashore,jessore,satkhira,bagerhat,kushtia,chuadanga,meherpur,jhenaidah,magura,narail,' +
    'barishal,barisal,patuakhali,bhola,pirojpur,jhalokati,jhalakathi,jhalokathi,barguna,' +
    'sylhet,moulvibazar,maulvibazar,habiganj,hobiganj,sunamganj,' +
    'rangpur,dinajpur,kurigram,gaibandha,nilphamari,lalmonirhat,thakurgaon,panchagarh,' +
    'mymensingh,jamalpur,netrokona,netrakona,sherpur,' +
    'গাজীপুর,নারায়ণগঞ্জ,নরসিংদী,মানিকগঞ্জ,মুন্সীগঞ্জ,টাঙ্গাইল,কিশোরগঞ্জ,ফরিদপুর,চট্টগ্রাম,কক্সবাজার,' +
    'কুমিল্লা,ফেনী,নোয়াখালী,চাঁদপুর,ব্রাহ্মণবাড়িয়া,রাজশাহী,বগুড়া,পাবনা,সিরাজগঞ্জ,খুলনা,যশোর,কুষ্টিয়া,' +
    'বরিশাল,সিলেট,মৌলভীবাজার,হবিগঞ্জ,সুনামগঞ্জ,রংপুর,দিনাজপুর,ময়মনসিংহ,জামালপুর'
  ).split(',');

  function compactPlace(v) {
    return String(v || '').toLowerCase().replace(/[^a-zঀ-৿]/g, '');
  }

  function areaForCity(city) {
    var c = compactPlace(city);
    if (c.length < 3) return '';
    for (var i = 0; i < OUTSIDE_DHAKA.length; i++) {
      if (c.indexOf(OUTSIDE_DHAKA[i]) !== -1) return 'outside';
    }
    return c.indexOf('dhaka') !== -1 || c.indexOf('ঢাকা') !== -1 ? 'inside' : '';
  }

  function setArea(next) {
    area = next === 'outside' ? 'outside' : 'inside';
    var radios = root.querySelectorAll('input[name="tle-area"]');
    for (var i = 0; i < radios.length; i++) radios[i].checked = radios[i].value === area;
    renderSummary();
  }

  function areaFromCityField() {
    if (areaTouched) return;
    var next = areaForCity(detField('city'));
    if (next && next !== area) setArea(next);
  }

  /* Under the details, beside the button: the delivery the bill now carries and
     the total, so a change made by the City field is seen where the buyer is
     typing — the bill itself has scrolled away above the form by then. */
  function renderAreaHint() {
    if (!el.areaHint) return;
    var p = priceState();
    var show = p.count > 0 && el.details && !el.details.hidden && detField('city').length >= 2;
    el.areaHint.hidden = !show;
    if (!show) return;
    el.areaHint.textContent =
      T('sum.delivery') + ' · ' + T(area === 'outside' ? 'sum.outside' : 'sum.inside') + ' ' +
      money(p.ship) + ' — ' + T('sum.total') + ' ' + money(p.payable);
  }

  function validateDetails() {
    var ok = true;
    var name = detField('name');
    var phone = normalizeBdPhone(detField('phone'));
    var addr = detField('address');
    var city = detField('city');
    var email = detField('email');
    setFieldError('name', name.length >= 2 ? '' : T('det.errName'));
    if (name.length < 2) ok = false;
    setFieldError('phone', phone ? '' : T('det.errPhone'));
    if (!phone) ok = false;
    setFieldError('address', addr.length >= 6 ? '' : T('det.errAddress'));
    if (addr.length < 6) ok = false;
    setFieldError('city', city.length >= 2 ? '' : T('det.errCity'));
    if (city.length < 2) ok = false;
    setFieldError('email', emailOk(email) ? '' : T('det.errEmail'));
    if (!emailOk(email)) ok = false;
    if (!ok) {
      var firstBad = root.querySelector('[data-det][data-invalid="true"]');
      if (firstBad) {
        firstBad.focus();
        firstBad.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
      }
    }
    return ok ? { name: name, phone: phone, addr: addr, city: city, email: detField('email') } : null;
  }

  function checkoutPermalink(d) {
    var items = aggregate();
    if (!items.length) return '';
    var parts = [];
    for (var i = 0; i < items.length; i++) parts.push(items[i].id + ':' + items[i].quantity);
    var bits = String(d.name || '').split(' ');
    var q = [];
    var add = function (k, v) {
      if (v) q.push(encodeURIComponent(k) + '=' + encodeURIComponent(v));
    };
    var sp = 'checkout[shipping_address]';
    add('checkout[email]', d.email);
    add(sp + '[first_name]', bits[0] || d.name);
    add(sp + '[last_name]', bits.slice(1).join(' ') || '.');
    add(sp + '[address1]', d.addr);
    add(sp + '[city]', d.city);
    add(sp + '[country]', 'Bangladesh');
    add(sp + '[phone]', d.phone);
    /* Carried onto the order so the packing slip says what was actually sold:
       slots, not line items — two slots holding the same size aggregate into
       one line, so items.length would under-report the combo. Latin digits
       whatever the page language: this is read by the packer, and by Pathao. */
    var packs = 0;
    for (var s = 0; s < slots.length; s++) if (slots[s]) packs++;
    var label = packs + ' ' + (packs === 1 ? WORDS.noun || 'item' : WORDS.nouns || 'items');
    if (PER_PACK > 1) label += ' (' + packs * PER_PACK + ' ' + (WORDS.pieces || 'pieces') + ')';
    add('attributes[' + (WORDS.combo || 'Combo') + ']', label);
    add('attributes[Delivery area]', area === 'outside' ? 'Outside Dhaka' : 'Inside Dhaka');
    if (SOURCE) add('attributes[Source]', SOURCE);
    return '/cart/' + parts.join(',') + (q.length ? '?' + q.join('&') : '');
  }

  var busy = false;

  function checkout() {
    var items = aggregate();
    if (!items.length) {
      scrollToId('offer');
      return;
    }
    if (busy) return;

    /* Details are required before the hand-off, so the buyer never lands on an
       empty checkout form having already "finished" on this page. */
    if (el.details) {
      if (el.details.hidden) {
        el.details.hidden = false;
        renderSummary();
        var firstIn = el.details.querySelector('[data-det]');
        if (firstIn) {
          el.details.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
          window.setTimeout(function () { firstIn.focus(); }, reduceMotion ? 0 : 420);
        }
        return;
      }
      var d = validateDetails();
      if (!d) return;
      busy = true;
      if (el.ctaLabel) el.ctaLabel.textContent = T('sum.adding');
      setMsg('');
      window.location.href = checkoutPermalink(d);
      return;
    }
    busy = true;
    if (el.ctaLabel) el.ctaLabel.textContent = T('sum.adding');
    if (el.cta) el.cta.disabled = true;
    setMsg('');

    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: items })
    })
      .then(function (r) {
        return r
          .json()
          .then(function (body) {
            return { ok: r.ok, status: r.status, body: body };
          })
          .catch(function () {
            return { ok: r.ok, status: r.status, body: null };
          });
      })
      .then(function (res) {
        if (!res.ok) {
          var desc = res.body && (res.body.description || res.body.message);
          setMsg(res.status === 422 ? T('sum.errStock') : desc || T('sum.err'), 'error');
          busy = false;
          if (el.cta) el.cta.disabled = false;
          renderSummary();
          return;
        }
        toast(T('toast.added'));
        window.location.href = '/checkout';
      })
      .catch(function () {
        setMsg(T('sum.err'), 'error');
        busy = false;
        if (el.cta) el.cta.disabled = false;
        renderSummary();
      });
  }

  function readCart() {
    if (!window.fetch) return;
    fetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) {
        return r.json();
      })
      .then(function (c) {
        otherCartItems = c && c.item_count ? c.item_count : 0;
        renderSummary();
      })
      .catch(function () {});
  }

  /* ── Flourish: a short confetti burst the first time all four land ─────── */
  var bursted = false;

  function burst() {
    if (bursted || reduceMotion) return;
    bursted = true;
    var host = el.nudge;
    if (!host) return;
    var colours = ['#b98b33', '#d3a445', '#59663a', '#f4f2ea'];
    for (var i = 0; i < 16; i++) {
      var bit = document.createElement('span');
      var ang = (Math.PI * 2 * i) / 16;
      bit.style.cssText =
        'position:absolute;left:50%;top:50%;width:6px;height:6px;pointer-events:none;' +
        'border-radius:1px;background:' +
        colours[i % colours.length] +
        ';transform:translate(-50%,-50%);opacity:1;transition:transform .9s cubic-bezier(.2,.7,.3,1),opacity .9s ease';
      host.style.position = 'relative';
      host.appendChild(bit);
      (function (node, angle) {
        window.setTimeout(function () {
          var d = 60 + Math.random() * 70;
          node.style.transform =
            'translate(' +
            (Math.cos(angle) * d - 3) +
            'px,' +
            (Math.sin(angle) * d - 3) +
            'px) rotate(' +
            Math.random() * 320 +
            'deg)';
          node.style.opacity = '0';
        }, 20);
        window.setTimeout(function () {
          if (node.parentNode) node.parentNode.removeChild(node);
        }, 1100);
      })(bit, ang);
    }
  }

  /* ── Hero pack swap ─────────────────────────────────────────────────────
     The swatch rail under the hero photo reads as a control, so it is one: tap
     an item and the photo becomes that item. The new source is preloaded before
     the swap so the frame never flashes empty on a slow connection. */
  function setHero(index) {
    var st = STYLES[index];
    if (!st) return;

    var img = root.querySelector('[data-hero-img]');
    var label = root.querySelector('[data-hero-label]');
    var swatches = root.querySelectorAll('[data-hero]');

    for (var i = 0; i < swatches.length; i++) {
      swatches[i].setAttribute(
        'data-active',
        Number(swatches[i].getAttribute('data-hero')) === index ? 'true' : 'false'
      );
    }

    if (label) {
      label.removeAttribute('data-i18n');
      label.textContent = (st.kicker + ' · ' + st.name).toUpperCase();
    }

    if (!img) return;
    var large = st.imgLg || st.img;
    /* Preload the size this viewport will actually pick from the srcset — the
       900w file is pure waste on a phone, and this audience pays for its data. */
    var wide = window.innerWidth >= 940;
    var pre = new Image();
    pre.onload = function () {
      img.src = large;
      img.srcset = st.img + ' 520w, ' + large + ' 900w';
      img.alt = st.title;
      img.style.opacity = '';
    };
    pre.onerror = function () {
      img.style.opacity = '';
    };
    if (!reduceMotion) img.style.opacity = '0.35';
    pre.src = wide ? large : st.img;
  }

  /* ── Hero autoplay ──────────────────────────────────────────────────────
     Cycles the hero through the items so a visitor who never touches the rail
     still sees the range. Three stop conditions, all deliberate:
       · the visitor taps a swatch — they have taken control, so we stay out
       · the hero scrolls out of view — no point burning data or battery
       · prefers-reduced-motion, or the merchant set a fixed hero image
     Nothing is prefetched ahead of time; each step preloads only its own frame. */
  var autoTimer = null;
  var autoIndex = 0;
  var autoStopped = false;

  function autoStop() {
    autoStopped = true;
    if (autoTimer) {
      window.clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  function autoStart() {
    if (autoStopped || autoTimer || STYLES.length < 2) return;
    autoTimer = window.setInterval(function () {
      autoIndex = (autoIndex + 1) % STYLES.length;
      setHero(autoIndex);
    }, AUTOPLAY_MS);
  }

  function autoPause() {
    if (autoTimer) {
      window.clearInterval(autoTimer);
      autoTimer = null;
    }
  }

  function setupAutoplay() {
    if (!AUTOPLAY || reduceMotion) return;
    var frame = root.querySelector('.tle-hero__frame');
    /* No initially-active swatch means the merchant pinned a custom hero image;
       cycling would override their choice. */
    var active = root.querySelector('[data-hero][data-active="true"]');
    if (!frame || !active) return;
    autoIndex = Number(active.getAttribute('data-hero')) || 0;

    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            if (entries[i].isIntersecting) autoStart();
            else autoPause();
          }
        },
        { threshold: 0.25 }
      );
      io.observe(frame);
    } else {
      autoStart();
    }

    /* Hovering to read the markers should not fight the rotation. */
    frame.addEventListener('mouseenter', autoPause);
    frame.addEventListener('mouseleave', function () {
      if (!autoStopped) autoStart();
    });
  }

  /* ── Scroll choreography ───────────────────────────────────────────────── */
  function scrollToId(id) {
    var target = document.getElementById(id);
    if (!target) return;
    target.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'start' });
  }

  function setupReveal() {
    var items = root.querySelectorAll('.tle-rv');
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < items.length; i++) items[i].setAttribute('data-in', 'true');
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            entries[i].target.setAttribute('data-in', 'true');
            io.unobserve(entries[i].target);
          }
        }
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.06 }
    );
    for (var j = 0; j < items.length; j++) io.observe(items[j]);
  }

  function setupNav() {
    var nav = root.querySelector('[data-nav]');
    var spineNow = root.querySelector('[data-spine-now]');
    var sections = root.querySelectorAll('[data-sec-label]');
    var links = root.querySelectorAll('[data-nav-link]');

    /* Which section is current is tracked by IntersectionObserver, NOT by
       measuring every section on each scroll frame. The old version called
       getBoundingClientRect() on all five sections inside the rAF, forcing a
       synchronous layout on every frame of every scroll — the main reason this
       page felt like it was dragging. The scroll handler below now reads only
       pageYOffset, which costs nothing. */
    function markCurrent(id) {
      var label = '';
      for (var i = 0; i < sections.length; i++) {
        if (sections[i].id === id) label = sections[i].getAttribute('data-sec-label');
      }
      if (spineNow && label) spineNow.textContent = label;
      for (var j = 0; j < links.length; j++) {
        links[j].setAttribute(
          'aria-current',
          links[j].getAttribute('data-nav-link') === id ? 'true' : 'false'
        );
      }
    }

    if ('IntersectionObserver' in window && sections.length) {
      var seen = {};
      var secObs = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            seen[entries[i].target.id] = entries[i].isIntersecting;
          }
          /* Topmost section still in the upper band wins. */
          for (var k = sections.length - 1; k >= 0; k--) {
            if (seen[sections[k].id]) {
              markCurrent(sections[k].id);
              return;
            }
          }
        },
        { rootMargin: '-14% 0px -70% 0px' }
      );
      for (var s2 = 0; s2 < sections.length; s2++) secObs.observe(sections[s2]);
    }

    /* Pause the always-on animations while the hero is off screen. */
    var hero = document.getElementById('top');
    if ('IntersectionObserver' in window && hero) {
      var animObs = new IntersectionObserver(
        function (entries) {
          root.setAttribute('data-anim-paused', entries[0].isIntersecting ? 'false' : 'true');
        },
        { threshold: 0 }
      );
      animObs.observe(hero);
    }

    var onScroll = function () {
      var y = window.pageYOffset || document.documentElement.scrollTop;
      if (nav) nav.setAttribute('data-stuck', y > 12 ? 'true' : 'false');
      if (el.dock) el.dock.setAttribute('data-show', y > 420 ? 'true' : 'false');
      if (el.fcart) el.fcart.setAttribute('data-show', y > 420 ? 'true' : 'false');
    };

    var raf = false;
    window.addEventListener(
      'scroll',
      function () {
        if (raf) return;
        raf = true;
        window.requestAnimationFrame(function () {
          raf = false;
          onScroll();
        });
      },
      { passive: true }
    );
    onScroll();
  }

  /* ── Theme ─────────────────────────────────────────────────────────────── */
  function setTheme(next) {
    document.documentElement.setAttribute('data-theme', next);
    try {
      localStorage.setItem('tle-theme', next);
    } catch (e) {}
  }

  function currentTheme() {
    var attr = document.documentElement.getAttribute('data-theme');
    if (attr === 'dark' || attr === 'light') return attr;
    return window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
      ? 'dark'
      : 'light';
  }

  /* ── Events ────────────────────────────────────────────────────────────── */
  root.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;

    /* × is nested inside the slot card, so it must be tested first. */
    if (BAG) {
      if (t.closest('[data-bag-open]')) {
        openBag();
        return;
      }
      if (t.closest('[data-bag-close]')) {
        closeBag();
        return;
      }
      if (t.closest('[data-bag-browse]')) {
        closeBag();
        scrollToId('styles');
        return;
      }
      var lineEl = t.closest('[data-line]');
      if (lineEl) {
        var lv = Number(lineEl.getAttribute('data-line'));
        var at = -1;
        for (var li = slots.length - 1; li >= 0; li--) {
          if (slots[li] && slots[li].variantId === lv) {
            at = li;
            break;
          }
        }
        if (t.closest('[data-line-inc]') && at > -1 && !t.closest('[data-line-inc]').disabled) {
          var base = slots[at];
          slots.push({ styleIdx: base.styleIdx, variantId: base.variantId, size: base.size, price: base.price });
        } else if (t.closest('[data-line-dec]') && at > -1) {
          slots.splice(at, 1);
        } else if (t.closest('[data-line-rm]')) {
          for (var lj = slots.length - 1; lj >= 0; lj--) {
            if (slots[lj] && slots[lj].variantId === lv) slots.splice(lj, 1);
          }
        } else {
          return;
        }
        persistBag();
        render();
        return;
      }
    }

    var clearBtn = t.closest('[data-clear]');
    if (clearBtn) {
      slots[Number(clearBtn.getAttribute('data-clear'))] = null;
      bursted = false;
      render();
      toast(T('toast.removed'));
      return;
    }

    var slotBtn = t.closest('[data-slot]');
    if (slotBtn) {
      openPicker(Number(slotBtn.getAttribute('data-slot')));
      return;
    }

    var styleBtn = t.closest('[data-style]:not([data-variant])');
    if (styleBtn && el.pick && el.pick.getAttribute('data-open') === 'true') {
      renderPickSizes(Number(styleBtn.getAttribute('data-style')));
      return;
    }

    var sizeBtn = t.closest('[data-variant]');
    if (sizeBtn && !sizeBtn.disabled && BAG) {
      sel = {
        styleIdx: Number(sizeBtn.getAttribute('data-style')),
        variantId: Number(sizeBtn.getAttribute('data-variant')),
        size: sizeBtn.getAttribute('data-size'),
        price: Number(sizeBtn.getAttribute('data-price')) || UNIT
      };
      sheetMsg('');
      markPicked();
      var sp = el.pickBody.querySelector('[data-sheet-price]');
      if (sp) sp.textContent = money(sel.price);
      return;
    }
    if (t.closest('[data-bag-add]')) {
      if (addToBag()) {
        closePicker();
        toast(T('toast.bagAdded'));
      }
      return;
    }
    if (t.closest('[data-bag-buy]')) {
      if (addToBag()) openBag();
      return;
    }
    if (sizeBtn && !sizeBtn.disabled && SINGLE) {
      slots[0] = {
        styleIdx: Number(sizeBtn.getAttribute('data-style')),
        variantId: Number(sizeBtn.getAttribute('data-variant')),
        size: sizeBtn.getAttribute('data-size'),
        price: Number(sizeBtn.getAttribute('data-price')) || UNIT
      };
      setMsg('');
      markPicked();
      render();
      return;
    }
    if (sizeBtn && !sizeBtn.disabled) {
      var idx = pickSlot;
      if (idx < 0) return;
      slots[idx] = {
        styleIdx: Number(sizeBtn.getAttribute('data-style')),
        variantId: Number(sizeBtn.getAttribute('data-variant')),
        size: sizeBtn.getAttribute('data-size'),
        price: Number(sizeBtn.getAttribute('data-price')) || UNIT
      };
      closePicker();
      render();
      /* Chain into the next empty slot so filling the goal is one flow — but
         stop once the visitor's chosen tier is reached. */
      var filled = 0;
      for (var f = 0; f < slots.length; f++) if (slots[f]) filled++;
      var next = -1;
      if (filled < target) {
        for (var i = 0; i < slots.length; i++) {
          if (!slots[i]) {
            next = i;
            break;
          }
        }
      }
      if (next > -1) {
        window.setTimeout(function () {
          openPicker(next);
        }, 260);
      }
      return;
    }

    if (t.closest('[data-pick-back]')) {
      renderPickStyles();
      return;
    }

    if (t.closest('[data-pick-close]') || t.closest('.tle-pick__veil')) {
      closePicker();
      return;
    }

    var tierBtn = t.closest('[data-tier]');
    if (tierBtn) {
      target = Number(tierBtn.getAttribute('data-tier')) || SLOTS;
      renderTiers();
      renderNudge();
      scrollToId('offer');
      var open1 = -1;
      for (var q = 0; q < slots.length; q++) {
        if (!slots[q]) {
          open1 = q;
          break;
        }
      }
      if (open1 > -1) {
        window.setTimeout(function () {
          openPicker(open1);
        }, reduceMotion ? 60 : 620);
      }
      return;
    }

    var heroSw = t.closest('[data-hero]');
    if (heroSw) {
      autoStop();
      setHero(Number(heroSw.getAttribute('data-hero')));
      return;
    }

    /* Gallery card → build the combo here instead of navigating away. Modifier
       and middle clicks are left alone so "open in new tab" still works, and the
       href stays intact for crawlers and for a JS-less visitor. */
    var galCard = t.closest('[data-gal]');
    if (galCard && !ev.metaKey && !ev.ctrlKey && !ev.shiftKey && !ev.altKey && ev.button === 0) {
      ev.preventDefault();
      var styleIdx = Number(galCard.getAttribute('data-gal'));

      /* Never open a picker with nothing pickable in it. Counts what the other
         slots have already reserved, so the last unit cannot be double-claimed. */
      var st0 = STYLES[styleIdx];
      var pickable = 0;
      if (st0) {
        for (var v0 = 0; v0 < st0.variants.length; v0++) {
          var vv0 = st0.variants[v0];
          if (vv0.ok && Math.max(0, vv0.qty - claimed(vv0.id, -1)) > 0) pickable++;
        }
      }
      /* On a combo page an unpickable product means sold out. On a bag page
         it can also mean "the last piece is already in YOUR bag" — so the
         sheet opens anyway and shows the size as taken, instead of a toast
         calling it sold out. */
      if (!pickable && !NO_BUILDER) {
        toast(T('toast.soldout'));
        return;
      }

      if (NO_BUILDER) {
        pickSlot = SINGLE ? 0 : -1;
        el.pick.setAttribute('data-open', 'true');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        renderPickSizes(styleIdx);
        return;
      }

      var slot = -1;
      for (var g = 0; g < slots.length; g++) {
        if (!slots[g]) {
          slot = g;
          break;
        }
      }
      if (slot < 0) {
        /* Nothing silently replaced — tell them what to do instead. */
        toast(T('toast.full'));
        scrollToId('offer');
        return;
      }
      scrollToId('offer');
      window.setTimeout(function () {
        pickSlot = slot;
        el.pick.setAttribute('data-open', 'true');
        document.documentElement.style.overflow = 'hidden';
        document.body.style.overflow = 'hidden';
        /* Straight to step 2 — they already chose the pack by clicking it. */
        renderPickSizes(styleIdx);
      }, reduceMotion ? 60 : 520);
      return;
    }

    var langBtn = t.closest('[data-lang-btn]');
    if (langBtn) {
      setLang(langBtn.getAttribute('data-lang-btn'));
      return;
    }

    if (t.closest('[data-theme-toggle]')) {
      setTheme(currentTheme() === 'dark' ? 'light' : 'dark');
      return;
    }

    if (BAG && t.closest('[data-dock-cta]')) {
      if (bagCount()) openBag();
      else scrollToId('styles');
      return;
    }
    if (SINGLE && t.closest('[data-dock-cta]')) {
      scrollToId('styles');
      return;
    }
    if (t.closest('[data-cta]') || t.closest('[data-dock-cta]')) {
      checkout();
      return;
    }

    if (t.closest('[data-fcart]')) {
      var fp = priceState();
      if (PLAIN ? fp.count > 0 : fp.count === SLOTS) checkout();
      else scrollToId('offer');
      return;
    }

    var jump = t.closest('[data-jump]');
    if (jump) {
      ev.preventDefault();
      scrollToId(jump.getAttribute('data-jump'));
      return;
    }
  });

  root.addEventListener('change', function (ev) {
    var t = ev.target;
    if (t && t.name === 'tle-area') {
      areaTouched = true;
      area = t.value === 'outside' ? 'outside' : 'inside';
      renderSummary();
    }
  });

  root.addEventListener('input', function (ev) {
    var t = ev.target;
    if (!t || !t.getAttribute) return;
    var det = t.getAttribute('data-det');
    if (det === 'city') {
      areaFromCityField();
      renderAreaHint();
    }
    /* A corrected field drops its error as soon as it is right, not on the
       next press of the button. */
    if (det === 'email' && t.getAttribute('data-invalid') === 'true' && emailOk(detField('email'))) {
      setFieldError('email', '');
    }
  });

  document.addEventListener('keydown', function (ev) {
    if (ev.key === 'Escape' && el.bag && el.bag.getAttribute('data-open') === 'true') {
      closeBag();
      return;
    }
    if (ev.key === 'Escape' && el.pick && el.pick.getAttribute('data-open') === 'true') {
      closePicker();
      return;
    }
    /* Filled slots are divs with role=button, so Enter/Space need wiring. */
    if (ev.key !== 'Enter' && ev.key !== ' ') return;
    var focused = document.activeElement;
    if (!focused || !focused.getAttribute) return;
    if (focused.getAttribute('data-filled') === 'true') {
      ev.preventDefault();
      openPicker(Number(focused.getAttribute('data-slot')));
    }
  });

  /* ── A timed offer that has ended ─────────────────────────────────────────
     Everything that announces it — the hero's offer line, and the video row
     when its footage names the offer — carries data-offer-only. */
  function retireOffer() {
    if (!OFFER_OVER) return;
    var gone = root.querySelectorAll('[data-offer-only]');
    for (var i = 0; i < gone.length; i++) {
      var vid = gone[i].querySelectorAll('video');
      for (var j = 0; j < vid.length; j++) vid[j].pause();
      gone[i].hidden = true;
    }
  }

  /* ── On camera — the video row (the NCS drop pages' player) ───────────────
     Muted and looping; only the video MOST in view plays, so scrolling past a
     row never runs five downloads at once. Tap the frame to play or pause it,
     the speaker for sound — one loud video at a time. Where autoplay is
     refused (or reduced motion is asked for) the native controls appear
     instead, and a hidden tab pauses everything. */
  function setupVideos() {
    var vids = root.querySelectorAll('[data-vid]');
    if (!vids.length) return;
    var auto = !reduceMotion && 'IntersectionObserver' in window;
    var loud = null;
    var current = null;
    var observed = [];
    var ratios = [];

    function wrapOf(v) {
      return v.closest ? v.closest('[data-vid]') : null;
    }
    function setSound(wrap, v, on) {
      v.muted = !on;
      var btn = wrap.querySelector('[data-vid-sound]');
      if (btn) {
        btn.setAttribute('aria-pressed', on ? 'false' : 'true');
        btn.setAttribute('aria-label', T(on ? 'vid.off' : 'vid.on'));
      }
      if (on) loud = v;
      else if (loud === v) loud = null;
    }
    function manual(wrap, v) {
      if (wrap.getAttribute('data-vid-manual') === 'true') return;
      wrap.setAttribute('data-vid-manual', 'true');
      v.controls = true;
    }
    function play(wrap, v) {
      var p;
      try {
        p = v.play();
      } catch (e) {
        manual(wrap, v);
        return;
      }
      if (p && typeof p.catch === 'function') p.catch(function () { manual(wrap, v); });
    }
    function wire(wrap) {
      var v = wrap.querySelector('[data-vid-el]');
      if (!v) return;
      if (!auto) manual(wrap, v);
      wrap.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('[data-vid-sound]')) return;
        if (v.paused) {
          if (current && current !== wrap) {
            var other = current.querySelector('[data-vid-el]');
            if (other) other.pause();
          }
          current = wrap;
          play(wrap, v);
        } else {
          v.pause();
          if (current === wrap) current = null;
        }
      });
      var btn = wrap.querySelector('[data-vid-sound]');
      if (btn) {
        btn.setAttribute('aria-label', T('vid.on'));
        btn.addEventListener('click', function () {
          /* The button's own state decides, not v.muted: the `muted`
             attribute does not set the property everywhere, and a speaker that
             reads "on" must turn the sound on. */
          var turningOn = btn.getAttribute('aria-pressed') !== 'false';
          if (turningOn && loud && loud !== v) {
            var ow = wrapOf(loud);
            if (ow) setSound(ow, loud, false);
            else loud.muted = true;
          }
          setSound(wrap, v, turningOn);
          if (turningOn && v.paused) play(wrap, v);
        });
      }
      if (auto) observed.push(wrap);
    }
    function pick() {
      var bestI = -1;
      var best = 0.3;
      for (var i = 0; i < observed.length; i++) {
        if (ratios[i] > best) {
          best = ratios[i];
          bestI = i;
        }
      }
      var winner = bestI < 0 ? null : observed[bestI];
      if (winner === current) return;
      if (current) {
        var prev = current.querySelector('[data-vid-el]');
        if (prev) {
          prev.pause();
          if (loud === prev) setSound(current, prev, false);
        }
      }
      current = winner;
      if (current) {
        var cv = current.querySelector('[data-vid-el]');
        if (cv) play(current, cv);
      }
    }
    for (var w = 0; w < vids.length; w++) wire(vids[w]);
    if (auto && observed.length) {
      var vio = new IntersectionObserver(
        function (entries) {
          for (var i = 0; i < entries.length; i++) {
            var at = observed.indexOf(entries[i].target);
            if (at >= 0) ratios[at] = entries[i].intersectionRatio;
          }
          pick();
        },
        { threshold: [0, 0.3, 0.6, 0.9] }
      );
      for (var o = 0; o < observed.length; o++) {
        ratios[o] = 0;
        vio.observe(observed[o]);
      }
    }
    document.addEventListener('visibilitychange', function () {
      if (!document.hidden) return;
      for (var i = 0; i < vids.length; i++) {
        var v = vids[i].querySelector('[data-vid-el]');
        if (v && !v.paused) {
          v.pause();
          if (loud === v) setSound(vids[i], v, false);
        }
      }
    });
  }

  /* ── Boot ──────────────────────────────────────────────────────────────── */
  readEnglish();
  for (var seedKey in EN_JS) {
    if (Object.prototype.hasOwnProperty.call(EN_JS, seedKey) && EN[seedKey] == null) {
      EN[seedKey] = EN_JS[seedKey];
    }
  }

  var savedLang;
  var savedTheme;
  try {
    savedLang = localStorage.getItem('tle-lang');
    savedTheme = localStorage.getItem('tle-theme');
  } catch (e) {}
  if (savedTheme === 'dark' || savedTheme === 'light') {
    document.documentElement.setAttribute('data-theme', savedTheme);
  }
  restoreBag();
  setLang(savedLang === 'bn' ? 'bn' : 'en');

  retireOffer();
  setupReveal();
  setupNav();
  setupAutoplay();
  setupVideos();
  readCart();
})();
